/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getProject = /* GraphQL */ `
  query GetProject($PK: String!, $SK: String!) {
    getProject(PK: $PK, SK: $SK) {
      PK
      SK
      abstract
      purpose
      citation
      createdAt
      createdBy
      DOI
      eastLongitude
      endDate
      keywords
      license
      northLatitude
      researchProgramName
      southLatitude
      stakeholders
      startDate
      status
      title
      updatedAt
      vessels
      website
      westLongitude
      attachmentKeys
      fileSizes
      centerPoint
      dataVisualization
      publishStatus
      locked
      sponsors
      analyzedForNAVWARN
      backscatterAvailable
      soundingHardwareModel
      techniqueOfSounding
      dataAcquisitionSoftwareVersion
      dataProcessingSoftwareVersion
      horizontalCoordinatesSystem
      horizontalDatum
      projection
      positioningMethod
      positioningHardware
      benchmarkReference
      benchmarkCoordinates
      verticalReferenceSystem
      benchmarkReferenceHeight
      waterLevelReductionMethodFileApplied
      tidalStationReferenceVerticalReductionModel
      horizontalAccuracy
      verticalAccuracy
      soundingCorrectedForVesselDraft
      calibrationData
      IHO_CATZOC
      IHOOrderOfSurvey
      __typename
    }
  }
`;
export const listProjects = /* GraphQL */ `
  query ListProjects(
    $PK: String
    $SK: ModelStringKeyConditionInput
    $filter: ModelProjectFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listProjects(
      PK: $PK
      SK: $SK
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        PK
        SK
        abstract
        purpose
        citation
        createdAt
        createdBy
        DOI
        eastLongitude
        endDate
        keywords
        license
        northLatitude
        researchProgramName
        southLatitude
        stakeholders
        startDate
        status
        title
        updatedAt
        vessels
        website
        westLongitude
        attachmentKeys
        fileSizes
        centerPoint
        dataVisualization
        publishStatus
        locked
        sponsors
        analyzedForNAVWARN
        backscatterAvailable
        soundingHardwareModel
        techniqueOfSounding
        dataAcquisitionSoftwareVersion
        dataProcessingSoftwareVersion
        horizontalCoordinatesSystem
        horizontalDatum
        projection
        positioningMethod
        positioningHardware
        benchmarkReference
        benchmarkCoordinates
        verticalReferenceSystem
        benchmarkReferenceHeight
        waterLevelReductionMethodFileApplied
        tidalStationReferenceVerticalReductionModel
        horizontalAccuracy
        verticalAccuracy
        soundingCorrectedForVesselDraft
        calibrationData
        IHO_CATZOC
        IHOOrderOfSurvey
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const projectsByPublisher = /* GraphQL */ `
  query ProjectsByPublisher(
    $createdBy: String!
    $sortDirection: ModelSortDirection
    $filter: ModelProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    projectsByPublisher(
      createdBy: $createdBy
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        PK
        SK
        abstract
        purpose
        citation
        createdAt
        createdBy
        DOI
        eastLongitude
        endDate
        keywords
        license
        northLatitude
        researchProgramName
        southLatitude
        stakeholders
        startDate
        status
        title
        updatedAt
        vessels
        website
        westLongitude
        attachmentKeys
        fileSizes
        centerPoint
        dataVisualization
        publishStatus
        locked
        sponsors
        analyzedForNAVWARN
        backscatterAvailable
        soundingHardwareModel
        techniqueOfSounding
        dataAcquisitionSoftwareVersion
        dataProcessingSoftwareVersion
        horizontalCoordinatesSystem
        horizontalDatum
        projection
        positioningMethod
        positioningHardware
        benchmarkReference
        benchmarkCoordinates
        verticalReferenceSystem
        benchmarkReferenceHeight
        waterLevelReductionMethodFileApplied
        tidalStationReferenceVerticalReductionModel
        horizontalAccuracy
        verticalAccuracy
        soundingCorrectedForVesselDraft
        calibrationData
        IHO_CATZOC
        IHOOrderOfSurvey
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchProjects = /* GraphQL */ `
  query SearchProjects(
    $filter: SearchableProjectFilterInput
    $sort: [SearchableProjectSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableProjectAggregationInput]
  ) {
    searchProjects(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        PK
        SK
        abstract
        purpose
        citation
        createdAt
        createdBy
        DOI
        eastLongitude
        endDate
        keywords
        license
        northLatitude
        researchProgramName
        southLatitude
        stakeholders
        startDate
        status
        title
        updatedAt
        vessels
        website
        westLongitude
        attachmentKeys
        fileSizes
        centerPoint
        dataVisualization
        publishStatus
        locked
        sponsors
        analyzedForNAVWARN
        backscatterAvailable
        soundingHardwareModel
        techniqueOfSounding
        dataAcquisitionSoftwareVersion
        dataProcessingSoftwareVersion
        horizontalCoordinatesSystem
        horizontalDatum
        projection
        positioningMethod
        positioningHardware
        benchmarkReference
        benchmarkCoordinates
        verticalReferenceSystem
        benchmarkReferenceHeight
        waterLevelReductionMethodFileApplied
        tidalStationReferenceVerticalReductionModel
        horizontalAccuracy
        verticalAccuracy
        soundingCorrectedForVesselDraft
        calibrationData
        IHO_CATZOC
        IHOOrderOfSurvey
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getAttribute = /* GraphQL */ `
  query GetAttribute($PK: String!, $SK: String!) {
    getAttribute(PK: $PK, SK: $SK) {
      PK
      SK
      category
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAttributes = /* GraphQL */ `
  query ListAttributes(
    $PK: String
    $SK: ModelStringKeyConditionInput
    $filter: ModelAttributeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAttributes(
      PK: $PK
      SK: $SK
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        PK
        SK
        category
        name
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchAttributes = /* GraphQL */ `
  query SearchAttributes(
    $filter: SearchableAttributeFilterInput
    $sort: [SearchableAttributeSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableAttributeAggregationInput]
  ) {
    searchAttributes(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        PK
        SK
        category
        name
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getAdministration = /* GraphQL */ `
  query GetAdministration($PK: String!, $Date: Float!) {
    getAdministration(PK: $PK, Date: $Date) {
      PK
      Date
      projectID
      projectTitle
      userID
      fieldUpdated
      oldValue
      newValue
      status
      userInfo
      email
      visualization
      doi
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAdministrations = /* GraphQL */ `
  query ListAdministrations(
    $PK: String
    $Date: ModelFloatKeyConditionInput
    $filter: ModelAdministrationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAdministrations(
      PK: $PK
      Date: $Date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        PK
        Date
        projectID
        projectTitle
        userID
        fieldUpdated
        oldValue
        newValue
        status
        userInfo
        email
        visualization
        doi
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const requestsByUserInfo = /* GraphQL */ `
  query RequestsByUserInfo(
    $PK: String!
    $userInfo: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAdministrationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    requestsByUserInfo(
      PK: $PK
      userInfo: $userInfo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        PK
        Date
        projectID
        projectTitle
        userID
        fieldUpdated
        oldValue
        newValue
        status
        userInfo
        email
        visualization
        doi
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const requestsByUser = /* GraphQL */ `
  query RequestsByUser(
    $userID: String!
    $PK: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAdministrationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    requestsByUser(
      userID: $userID
      PK: $PK
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        PK
        Date
        projectID
        projectTitle
        userID
        fieldUpdated
        oldValue
        newValue
        status
        userInfo
        email
        visualization
        doi
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBlacklistsByEmail = /* GraphQL */ `
  query GetBlacklistsByEmail(
    $email: String!
    $PK: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAdministrationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getBlacklistsByEmail(
      email: $email
      PK: $PK
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        PK
        Date
        projectID
        projectTitle
        userID
        fieldUpdated
        oldValue
        newValue
        status
        userInfo
        email
        visualization
        doi
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAdministrationByVisualization = /* GraphQL */ `
  query GetAdministrationByVisualization(
    $visualization: String!
    $PK: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAdministrationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getAdministrationByVisualization(
      visualization: $visualization
      PK: $PK
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        PK
        Date
        projectID
        projectTitle
        userID
        fieldUpdated
        oldValue
        newValue
        status
        userInfo
        email
        visualization
        doi
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchAdministrations = /* GraphQL */ `
  query SearchAdministrations(
    $filter: SearchableAdministrationFilterInput
    $sort: [SearchableAdministrationSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableAdministrationAggregationInput]
  ) {
    searchAdministrations(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        PK
        Date
        projectID
        projectTitle
        userID
        fieldUpdated
        oldValue
        newValue
        status
        userInfo
        email
        visualization
        doi
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
